import * as React from "react";

import loadingAnimation from "@v2/components/reploader.json";
import Lottie from "lottie-react";

export function FullScreenLoader() {
  return (
    <div className="position--center z-max fixed h-screen w-screen bg-white flex items-center justify-center">
      <Lottie
        animationData={loadingAnimation}
        loop={true}
        className="z-10 w-[200px]"
      />
    </div>
  );
}
